import { Component, createRef } from 'react'
import { Slider } from 'antd'
import cx from 'classnames'
import { autobind } from 'core-decorators'
import debounce from 'lodash/debounce'
import PropTypes from 'prop-types'

import classNames from './styles.module.scss'


const propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

const defaultProps = {
  name: 'default',
  value: 0,
}

export default class SliderInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: 0,
      isMounted: false,
    }
    this.debounceChange = debounce(this.formChange, 300)
    this.containerRef = createRef()
  }

  @autobind
  formChange(value) {
    return this.props.onChange(value)
  }

  @autobind
  handleChange(value) {
    this.setState({ value }, _ => {
      return this.debounceChange(value)
    })
  }

  componentDidUpdate(prevProps) {
    if(prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  componentDidMount() {
    this.setState({ value: this.props.value, isMounted: true })
  }

  render() {
    if(!this.state.isMounted) {
      return null
    }
    return (
      <div className={cx(classNames.sliderWrapper)} id={this.props.name} ref={this.containerRef}>
        <Slider
          {...this.props}
          getTooltipPopupContainer={_ => this.containerRef.current}
          value={this.state.value}
          onChange={this.handleChange}
          tooltipPlacement="top"
        />
      </div>
    )
  }
}

SliderInput.propTypes = propTypes
SliderInput.defaultProps = defaultProps
